import { RichText } from 'prismic-reactjs';
import { IDeliveryFeesTableProps } from './types';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { DELIVERY_FEES } from '@monofront/business/constants';
import { format } from '@monofront/business/utils';
import { useTranslations } from 'next-intl';

const DeliveryFeesTable: React.FC<IDeliveryFeesTableProps> = ({ primary }) => {
  const tDelivery = useTranslations('Shipping.deliveryFees');
  const tShipping = useTranslations('Shipping');
  const deliveryNoticeTiers = useFeatureValue(...DELIVERY_FEES);
  const formatPrice: (price: number) => string = (price) => {
    if (price === 0) {
      return tShipping('free');
    }

    return format(price / 100);
  };

  return (
    <section className="[&>h1]:tw-lf-title-sm [&>p]:tw-lf-body-regular-md [&>*]:tw-my-2">
      <RichText render={primary.title} />
      <RichText
        className="tw-lf-body-regular-md"
        render={primary.description}
      />
      <table className="tw-w-full">
        <tbody>
          {primary.deliveryNoticeTiers &&
            deliveryNoticeTiers?.[primary.deliveryNoticeTiers]?.map(
              ({ aboveAmount, underAmount, price }, i) => (
                <th
                  key={i}
                  className="tw-lf-body-regular-md tw-lf-list-box-line tw-m-0 tw-p-0.5 odd:tw-bg-blue-100"
                >
                  <tr className="tw-w-2/3 tw-text-left">
                    {tDelivery(
                      aboveAmount && underAmount
                        ? 'between'
                        : aboveAmount
                        ? 'above'
                        : 'under',
                      {
                        aboveAmount: aboveAmount && formatPrice(aboveAmount),
                        underAmount: underAmount && formatPrice(underAmount),
                      },
                    )}
                  </tr>
                  <tr className="tw-w-1/3 tw-text-right">
                    {formatPrice(price)}
                  </tr>
                </th>
              ),
            )}
        </tbody>
      </table>
      {primary.bottomTableText && <RichText render={primary.bottomTableText} />}
    </section>
  );
};

export default DeliveryFeesTable;
